module.exports = __webpack_public_path__ + "static/img/logo.1346cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1